import gql from 'graphql-tag'

export const VIEW_VACANCY_SUBSCRIPTION = gql`
  subscription ViewVacancySubscription {
    viewVacancy
  }
`